/**
 * App navigation flow to different places of Services Menu
 * @module Services-Navigation-Routes
 */

import { Route, Routes } from "react-router-dom";
import { route } from "../globals/constants";
import { Navigate } from "react-router-dom";
import ServicesDetailPage from "../app/components/services/services-detail";
import ITConsultancyPage from "../app/components/services/it-consultancy";
import CustomSoftwarePage from "../app/components/services/custom-software";
import MobileWebDevelopmentPage from "../app/components/services/mobile-development";
import PaymentSolutionsPage from "../app/components/services/payment-gateway";
import ITSecurityTrainingPage from "../app/components/services/it-security";

/**
 * @returns - Describes navigation for different sub-menus of Services Menu:
 ** {@link ServicesDetailPage}
 ** {@link ITConsultancyPage}
 ** {@link CustomSoftwarePage}
 ** {@link MobileWebDevelopmentPage}
 ** {@link PaymentSolutionsPage}
 ** {@link ITSecurityTrainingPage}
 */
const ServicesRoutes = () => {
    return (
        <Routes>
            <Route path={route.services.DETAIL} element={<ServicesDetailPage />} />
            <Route path={route.services.IT_CONSULTANCY} element={<ITConsultancyPage />} />
            <Route path={route.services.CUSTOM_SOFTWARE} element={<CustomSoftwarePage />} />
            <Route path={route.services.MOBILE_DEVELOPMENT} element={<MobileWebDevelopmentPage />} />
            <Route path={route.services.PAYMENT_GATEWAY} element={<PaymentSolutionsPage />} />
            <Route path={route.services.IT_SECURITY} element={<ITSecurityTrainingPage />} />
            {/* Redirect main services route to IT Consultancy */}
            <Route path="" element={<Navigate to={route.services.IT_CONSULTANCY} replace />} />
        </Routes>
    )
}
export default ServicesRoutes;